/* ==========================================================================
   Soon Maternity — Size Guide popup (all sized products EXCEPT denim)
   Vanilla JS, no dependencies. Namespaced "soon-sg" so it can never clash
   with the Denim Size Guide ("soon-dsg"), the Fit Guide popup, Broadcast or
   any app. Delegated listeners, guarded so a Theme Editor re-render can't
   bind them twice.

   TO EDIT SIZES OR TAB TEXT: change SIZES / TABS below. All measurements
   are in cm (inches are calculated automatically).
   ========================================================================== */
(function () {
  if (window.__soonSgBound) return;
  window.__soonSgBound = true;

  // ---- Size data (cm) — shared by every tab ---------------------------
  var SIZES = [
    { intl: 'XS',  au: '6',     us: '2',    eu: '34',    bust: [83, 88],   hip: [88, 93] },
    { intl: 'S',   au: '8',     us: '4',    eu: '36',    bust: [88, 93],   hip: [93, 98] },
    { intl: 'M',   au: '10',    us: '6',    eu: '38',    bust: [93, 98],   hip: [98, 103] },
    { intl: 'L',   au: '12',    us: '8',    eu: '40',    bust: [98, 103],  hip: [103, 108] },
    { intl: 'XL',  au: '14',    us: '10',   eu: '42',    bust: [103, 108],  hip: [108, 113] },
    { intl: 'XXL', au: '16',    us: '12',   eu: '44',    bust: [108, 113], hip: [113, 118] },
    { intl: 'XXXL', au: '18',    us: '14',   eu: '46',    bust: [113, 118], hip: [118, 123] }
  ];

  // ---- Tabs: which measurement(s) each category matches on ------------
  var TABS = {
    tops: {
      label: 'Tops',
      measures: ['bust'],
      desc: 'For tops, we size by bust. Measure around the fullest part of your bust, keeping the tape level all the way around, then enter the full measurement below.'
    },
    dresses: {
      label: 'Dresses',
      measures: ['bust', 'hip'],
      desc: 'For dresses, we use your bust and hip. Measure around the fullest part of each, keeping the tape level. If they point to different sizes, we suggest the larger one.'
    },
    bottoms: {
      label: 'Bottoms',
      measures: ['hip'],
      desc: 'For bottoms, we size by full hip. Measure around the fullest part of your hips and bottom, keeping the tape level, then enter the full measurement below — not half of it.'
    }
  };
  var DEFAULT_TAB = 'tops';
  var LABELS = { bust: 'Bust', hip: 'Full hip' };

  // ---- Helpers ------------------------------------------------------------
  function toIn(cm) {
    var v = Math.round((cm / 2.54) * 2) / 2;
    return String(v).replace(/\.0$/, '');
  }
  function fmtRange(r, unit) {
    return unit === 'cm' ? r[0] + '–' + r[1] + 'cm' : toIn(r[0]) + '–' + toIn(r[1]) + '"';
  }
  function getState(root) {
    if (!root.__soonSgState) {
      root.__soonSgState = { unit: 'cm', tab: DEFAULT_TAB, submitted: false, lastFocused: null };
    }
    return root.__soonSgState;
  }
  function readCm(root, m) {
    var input = root.querySelector('[data-soon-sg-input="' + m + '"]');
    if (!input) return NaN;
    var raw = parseFloat(input.value);
    if (!isFinite(raw) || raw <= 0) return NaN;
    return getState(root).unit === 'in' ? raw * 2.54 : raw;
  }

  // Returns { status: 'none'|'below'|'above'|'match'|'between', idx: [..], differ: bool }
  function compute(root) {
    var state = getState(root);
    var measures = TABS[state.tab].measures;
    var perMeasure = [];
    var anyAbove = false;
    var allBelow = true;

    for (var i = 0; i < measures.length; i++) {
      var m = measures[i];
      var cm = readCm(root, m);
      if (!isFinite(cm)) return { status: 'none', idx: [] };
      var hits = [];
      SIZES.forEach(function (s, n) { if (cm >= s[m][0] && cm <= s[m][1]) hits.push(n); });
      if (!hits.length) {
        if (cm < SIZES[0][m][0]) { hits = [0]; }
        else { anyAbove = true; hits = [SIZES.length - 1]; }
      } else {
        allBelow = false;
      }
      if (cm >= SIZES[0][m][0]) allBelow = false;
      perMeasure.push(hits);
    }

    if (anyAbove) return { status: 'above', idx: [] };
    if (allBelow) return { status: 'below', idx: [] };

    var rec = 0;
    perMeasure.forEach(function (h) { rec = Math.max(rec, h[0]); });
    var between = perMeasure.some(function (h) { return h.indexOf(rec + 1) !== -1; });
    var differ = perMeasure.length > 1 && perMeasure[0][0] !== perMeasure[1][0];

    if (between) return { status: 'between', idx: [rec, rec + 1], differ: differ };
    return { status: 'match', idx: [rec], differ: differ };
  }

  // ---- Rendering ----------------------------------------------------------
  function render(root) {
    var state = getState(root);
    var tab = TABS[state.tab];
    var unit = state.unit;
    var res = state.submitted ? compute(root) : { status: 'none', idx: [] };

    // Tabs
    root.querySelectorAll('[data-soon-sg-tab]').forEach(function (b) {
      var on = b.getAttribute('data-soon-sg-tab') === state.tab;
      b.setAttribute('aria-selected', String(on));
      b.setAttribute('tabindex', on ? '0' : '-1');
    });

    // Copy + category name
    var descEl = root.querySelector('[data-soon-sg-desc]');
    if (descEl) descEl.textContent = tab.desc;
    var nameEl = root.querySelector('[data-soon-sg-tab-name]');
    if (nameEl) nameEl.textContent = tab.label;

    // Show only the inputs this tab needs
    root.querySelectorAll('[data-soon-sg-field]').forEach(function (f) {
      f.hidden = tab.measures.indexOf(f.getAttribute('data-soon-sg-field')) === -1;
    });
    root.querySelectorAll('[data-soon-sg-label]').forEach(function (l) {
      var m = l.getAttribute('data-soon-sg-label');
      l.textContent = LABELS[m] + ' (' + (unit === 'cm' ? 'cm' : 'inches') + ')';
    });

    // Table head
    var thead = root.querySelector('[data-soon-sg-thead]');
    if (thead) {
      var cols = ['Size', 'AU / UK', 'US', 'EU'].concat(tab.measures.map(function (m) { return LABELS[m]; }));
      thead.innerHTML = '';
      var htr = document.createElement('tr');
      cols.forEach(function (c) { var th = document.createElement('th'); th.textContent = c; htr.appendChild(th); });
      thead.appendChild(htr);
    }

    // Table body
    var body = root.querySelector('[data-soon-sg-tbody]');
    if (body) {
      body.innerHTML = '';
      SIZES.forEach(function (s, n) {
        var tr = document.createElement('tr');
        if (res.idx.indexOf(n) !== -1) tr.className = 'is-match';
        var vals = [s.intl, s.au, s.us, s.eu].concat(tab.measures.map(function (m) { return fmtRange(s[m], unit); }));
        vals.forEach(function (v) { var td = document.createElement('td'); td.textContent = v; tr.appendChild(td); });
        body.appendChild(tr);
      });
    }

    renderResult(root, res);
  }

  function renderResult(root, res) {
    var resultEl = root.querySelector('[data-soon-sg-result]');
    if (!resultEl) return;
    if (!res || res.status === 'none') { resultEl.hidden = true; return; }

    var kicker = '', size = '', note = '';
    var first = SIZES[0], last = SIZES[SIZES.length - 1];

    if (res.status === 'below') {
      kicker = 'Below our size range';
      size = first.intl + '  ·  AU ' + first.au;
      note = first.intl + ' is our smallest size. Get in touch and we can help you find the right fit.';
    } else if (res.status === 'above') {
      kicker = 'Above our size range';
      size = last.intl + '  ·  AU ' + last.au;
      note = last.intl + ' is our largest size. Get in touch and we can help you find the right fit.';
    } else if (res.status === 'match') {
      var s = SIZES[res.idx[0]];
      kicker = 'Your recommended size';
      size = s.intl + '  ·  AU ' + s.au + '  ·  US ' + s.us + '  ·  EU ' + s.eu;
      note = res.differ
        ? 'Your bust and hip point to different sizes, so we have suggested the larger one. Highlighted in the chart below.'
        : 'Highlighted in the chart below.';
    } else {
      var a = SIZES[res.idx[0]], b = SIZES[res.idx[1]];
      kicker = 'You sit between two sizes';
      size = (a.intl === b.intl ? '' : a.intl + ' or ' + b.intl + '  ·  ') + 'AU ' + a.au + ' or AU ' + b.au;
      note = 'Choose the larger size for a looser, more relaxed fit, or the smaller size for a more fitted look.';
    }

    var k = root.querySelector('[data-soon-sg-result-kicker]');
    var z = root.querySelector('[data-soon-sg-result-size]');
    var t = root.querySelector('[data-soon-sg-result-note]');
    if (k) k.textContent = kicker;
    if (z) z.textContent = size;
    if (t) t.textContent = note;
    resultEl.hidden = false;
  }

  // ---- Body scroll lock (iOS safe) ----------------------------------------
  var lockCount = 0, lockY = 0;
  function lockBody() {
    if (lockCount === 0) {
      lockY = window.scrollY || window.pageYOffset || 0;
      var bs = document.body.style;
      bs.position = 'fixed'; bs.top = (-lockY) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%';
    }
    lockCount++;
  }
  function unlockBody() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      var bs = document.body.style;
      bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = '';
      window.scrollTo(0, lockY);
    }
  }

  // ---- Focus trap -----------------------------------------------------------
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trapFocus(root, e) {
    if (e.key !== 'Tab') return;
    var panel = root.querySelector('.soon-dsg__panel');
    if (!panel) return;
    var els = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!els.length) return;
    var f = els[0], l = els[els.length - 1];
    if (e.shiftKey && document.activeElement === f) { e.preventDefault(); l.focus(); }
    else if (!e.shiftKey && document.activeElement === l) { e.preventDefault(); f.focus(); }
  }

  // ---- Open / close ---------------------------------------------------------
  function openPopup(root, trigger) {
    var state = getState(root);
    state.lastFocused = trigger || document.activeElement;
    render(root);
    root.removeAttribute('hidden');
    root.setAttribute('data-open', '');
    lockBody();
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var c = root.querySelector('[data-soon-sg-close]');
    (c || root).focus();
  }
  function closePopup(root) {
    var state = getState(root);
    root.removeAttribute('data-open');
    root.setAttribute('hidden', '');
    unlockBody();
    var ts = document.querySelectorAll('[data-soon-sg-trigger][aria-controls="' + root.id + '"]');
    for (var i = 0; i < ts.length; i++) ts[i].setAttribute('aria-expanded', 'false');
    if (state.lastFocused && typeof state.lastFocused.focus === 'function') state.lastFocused.focus();
  }

  // ---- Delegated events -------------------------------------------------------
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el.closest) return;

    var trigger = el.closest('[data-soon-sg-trigger]');
    if (trigger) {
      var id = trigger.getAttribute('aria-controls');
      var r = id ? document.getElementById(id) : null;
      if (r) { e.preventDefault(); openPopup(r, trigger); }
      return;
    }

    var root = el.closest('[data-soon-sg-root]');
    if (!root) return;
    var state = getState(root);

    if (el.closest('[data-soon-sg-close], [data-soon-sg-overlay]')) { closePopup(root); return; }

    var tabBtn = el.closest('[data-soon-sg-tab]');
    if (tabBtn) {
      state.tab = tabBtn.getAttribute('data-soon-sg-tab');
      render(root);
      return;
    }

    var unitBtn = el.closest('[data-soon-sg-unit]');
    if (unitBtn) {
      var unit = unitBtn.getAttribute('data-soon-sg-unit');
      if (unit !== state.unit) {
        state.unit = unit;
        state.submitted = false;
        root.querySelectorAll('[data-soon-sg-unit]').forEach(function (b) {
          var on = b === unitBtn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', String(on));
        });
        root.querySelectorAll('[data-soon-sg-input]').forEach(function (i) {
          i.placeholder = unit === 'cm' ? 'e.g. 92' : 'e.g. 36';
        });
        render(root);
      }
      return;
    }

    if (el.closest('[data-soon-sg-find]')) { state.submitted = true; render(root); }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-soon-sg-input]')) return;
    var root = e.target.closest('[data-soon-sg-root]');
    if (!root) return;
    getState(root).submitted = false;
    render(root);
  });

  document.addEventListener('keydown', function (e) {
    if (e.target.matches && e.target.matches('[data-soon-sg-input]') && e.key === 'Enter') {
      var r = e.target.closest('[data-soon-sg-root]');
      if (r) { e.preventDefault(); getState(r).submitted = true; render(r); }
      return;
    }
    var open = document.querySelector('[data-soon-sg-root][data-open]');
    if (!open) return;

    // Arrow keys move between tabs
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && e.target.matches && e.target.matches('[data-soon-sg-tab]')) {
      var keys = Object.keys(TABS);
      var st = getState(open);
      var n = keys.indexOf(st.tab) + (e.key === 'ArrowRight' ? 1 : -1);
      st.tab = keys[(n + keys.length) % keys.length];
      render(open);
      var next = open.querySelector('[data-soon-sg-tab="' + st.tab + '"]');
      if (next) next.focus();
      e.preventDefault();
      return;
    }
    if (e.key === 'Escape') { closePopup(open); return; }
    trapFocus(open, e);
  });
})();